import { motion } from 'framer-motion';
import chairmanImg from "../assets/gallery/newaddpicbessandsolarpic/md.jpg";
import '../styles/Team.scss';

const Team = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  const imageVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        delay: 0.2,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  return (
    <section className="team-section section-padding" id="team">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="section-header text-center mb-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
        >
          <h2 className="section-title">Leadership Team</h2>
          <p className="section-subtitle">
            Meet the visionary leader driving India's renewable energy transformation
          </p>
        </motion.div>

        {/* Team Card */}
        <motion.div
          className="row justify-content-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
        >
          <div className="col-12 col-xl-10">
            <div className="team-card">
              <div className="row g-0 h-100">
                {/* Image Column */}
                <div className="col-lg-5 col-md-6">
                  <motion.div
                    className="team-image-container"
                    variants={imageVariants}
                  >
                    <div className="team-image">
                      <img
                        src={chairmanImg}
                        alt="Er Ram Jangid - Managing Director"
                        className="img-fluid"
                      />
                      <div className="image-overlay">
                        <h3 className="overlay-name">Er Ram Jangid</h3>
                        <p className="overlay-role">Managing Director</p>
                      </div>
                    </div>
                  </motion.div>
                </div>

                {/* Content Column */}
                <div className="col-lg-7 col-md-6">
                  <motion.div
                    className="team-content"
                    variants={contentVariants}
                  >
                    <div className="leadership-badge">
                      <span>Leadership</span>
                    </div>

                    <h3 className="team-name">Er Ram Jangid</h3>

                    <div className="team-role">
                      <span className="role-line"></span>
                      Managing Director
                    </div>

                    <div className="team-bio">
                      <p>
                        At the helm of Rama Reflection India Pvt. Ltd. is a visionary Founder and Managing Director—an accomplished engineer and leader in the renewable energy sector. Over the past decade, he has spearheaded impactful solar projects across rural Rajasthan, transforming barren land into reliable sources of clean power.
                      </p>

                      <div className="highlight-box">
                        <p>
                          With more than <strong>2 GW+</strong> of solar capacity executed across India, he is a recognized leader in Ground-Mounted Solar PV Projects, Battery Energy Storage Systems (BESS), and emerging clean technologies.
                        </p>
                      </div>

                      <p>
                        An engineer by qualification and an innovator by mindset, he has redefined the role of renewable energy in both urban industrial development and rural upliftment. Under his leadership, RRIPL has grown into a trusted name in delivering large-scale, sustainable energy solutions.
                      </p>
                    </div>
                    {/* 
                    <div className="team-stats">
                      <div className="row g-3">
                        <div className="col-6 col-sm-4">
                          <div className="stat-item">
                            <div className="stat-number">2 GW+</div>
                            <div className="stat-label">Solar Capacity</div>
                          </div>
                        </div>
                        <div className="col-6 col-sm-4">
                          <div className="stat-item">
                            <div className="stat-number">10+</div>
                            <div className="stat-label">Years Experience</div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="stat-item">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Projects Delivered</div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Team;
